import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import {
  BoundaryManagementRoutingModule, ChangeOwnerPopupComponent, ViewBoundariesListComponent
} from '@app/modules/boundary-management';
import { ReusableAddNotesWithHistoryPopupComponent, SharedModule } from '@app/shared';
import { LeafletComponentsModule } from '@app/shared/components/leaf-let';
import { MaterialModule } from '@app/shared/material.module';
import { RequestSearchListComponent } from '@modules/my-tasks/components/boundary-management/gis/request-search-list.component';
import { boundaryManagementDeclarationComponents } from './';
@NgModule({
  declarations: [...boundaryManagementDeclarationComponents],
  imports: [
    BoundaryManagementRoutingModule,
    MaterialModule, LeafletComponentsModule,
    SharedModule, MatMenuModule
  ],
  entryComponents: [ChangeOwnerPopupComponent,ReusableAddNotesWithHistoryPopupComponent],
  exports: [ViewBoundariesListComponent, RequestSearchListComponent]
})
export class BoundaryManagementModule { }
